import apiClient from '$utils/apiClient';

const lti1p3Start = async ({
  spaceId,
  clientId,
  type,
  userId,
  resourceLinkId,
  resourceLinkTitle,
  assignmentId,
  assignmentFormData,
}) => {
  let payload = {
    spaceId,
    clientId,
    type,
    resourceLinkId,
  };

  if (resourceLinkTitle) {
    payload = { ...payload, resourceLinkTitle };
  }

  if (assignmentId) {
    payload = { ...payload, assignmentId };
  }

  if (assignmentFormData) {
    payload = { ...payload, assignmentFormData };
  }

  const result = await apiClient.post('/lti/1p3/start', payload, {
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json',
      'x-user-id': userId,
    },
  });

  const { ltiSessionToken } = result.data;
  return ltiSessionToken;
};

export default lti1p3Start;
